(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-display-top"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function oloePad(n) {
      n = Math.max(0, n);
      return String(n).length < 2 ? '0' + n : String(n);
    }

    function oloeStartCountdown(el) {
      var endRaw = el.getAttribute('data-end');
      if (!endRaw) return;
      var endDate = new Date(endRaw);
      if (isNaN(endDate.getTime())) return;

      var hideOnExpire = el.getAttribute('data-hide-on-expire') === 'true';
      var expiredText = el.getAttribute('data-expired-text') || 'Sale has ended';
      var timerId = null;

      var dayEls = el.querySelectorAll('[data-unit="days"]');
      var hourEls = el.querySelectorAll('[data-unit="hours"]');
      var minEls = el.querySelectorAll('[data-unit="minutes"]');
      var secEls = el.querySelectorAll('[data-unit="seconds"]');

      function setUnit(nodeList, value) {
        nodeList.forEach(function (node) { node.textContent = oloePad(value); });
      }

      function tick() {
        var diff = endDate.getTime() - Date.now();
        if (diff <= 0) {
          if (timerId) clearInterval(timerId);
          if (hideOnExpire) {
            el.style.display = 'none';
          } else {
            el.innerHTML = '<span class="oloe-cd-expired">' + expiredText + '</span>';
          }
          return;
        }
        var totalSeconds = Math.floor(diff / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;
        setUnit(dayEls, days);
        setUnit(hourEls, hours);
        setUnit(minEls, minutes);
        setUnit(secEls, seconds);
      }

      tick();
      timerId = setInterval(tick, 1000);
    }

    function oloeInitCountdowns() {
      document.querySelectorAll('.oloe-countdown-timer[data-end]').forEach(oloeStartCountdown);
    }

    /* ------------------------------------------------------------
       Desktop click-to-expand gallery lightbox (Aug 2026)
       Opens on click for any gallery image (hero or 2-up grid tile)
       when the viewport is 990px or wider. Includes prev/next arrows
       to browse through every image in that product's gallery.
    ------------------------------------------------------------ */
    var oloeLightboxState = { images: [], index: 0 };

    function oloeIsDesktopViewport() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    function oloeGetGalleryImages(galleryEl) {
      return Array.prototype.map.call(
        galleryEl.querySelectorAll('img[data-lightbox-full]'),
        function (img) {
          return {
            full: img.getAttribute('data-lightbox-full'),
            alt: img.getAttribute('alt') || ''
          };
        }
      );
    }

    function oloeRenderLightbox(lb) {
      var item = oloeLightboxState.images[oloeLightboxState.index];
      if (!item) return;
      var imgEl = lb.querySelector('.oloe-lightbox__img');
      imgEl.src = item.full;
      imgEl.alt = item.alt;
      var multi = oloeLightboxState.images.length > 1;
      lb.querySelector('.oloe-lightbox__prev').style.display = multi ? '' : 'none';
      lb.querySelector('.oloe-lightbox__next').style.display = multi ? '' : 'none';
    }

    function oloeCloseLightbox(lb) {
      lb.classList.remove('is-open');
      document.body.classList.remove('oloe-lightbox-open');
    }

    function oloeStepLightbox(lb, delta) {
      var total = oloeLightboxState.images.length;
      if (!total) return;
      oloeLightboxState.index = (oloeLightboxState.index + delta + total) % total;
      oloeRenderLightbox(lb);
    }

    function oloeEnsureLightbox() {
      var lb = document.getElementById('oloe-pdp-lightbox');
      if (lb) return lb;

      lb = document.createElement('div');
      lb.id = 'oloe-pdp-lightbox';
      lb.className = 'oloe-lightbox';
      lb.innerHTML =
        '<button type="button" class="oloe-lightbox__close" aria-label="Close">&times;</button>' +
        '<button type="button" class="oloe-lightbox__nav oloe-lightbox__prev" aria-label="Previous image">&#10094;</button>' +
        '<div class="oloe-lightbox__stage"><img class="oloe-lightbox__img" src="" alt=""></div>' +
        '<button type="button" class="oloe-lightbox__nav oloe-lightbox__next" aria-label="Next image">&#10095;</button>';
      document.body.appendChild(lb);

      lb.querySelector('.oloe-lightbox__close').addEventListener('click', function () {
        oloeCloseLightbox(lb);
      });
      lb.querySelector('.oloe-lightbox__prev').addEventListener('click', function () {
        oloeStepLightbox(lb, -1);
      });
      lb.querySelector('.oloe-lightbox__next').addEventListener('click', function () {
        oloeStepLightbox(lb, 1);
      });
      lb.addEventListener('click', function (evt) {
        if (evt.target === lb) oloeCloseLightbox(lb);
      });
      document.addEventListener('keydown', function (evt) {
        if (!lb.classList.contains('is-open')) return;
        if (evt.key === 'Escape') oloeCloseLightbox(lb);
        if (evt.key === 'ArrowLeft') oloeStepLightbox(lb, -1);
        if (evt.key === 'ArrowRight') oloeStepLightbox(lb, 1);
      });

      return lb;
    }

    function oloeOpenLightbox(images, index) {
      var lb = oloeEnsureLightbox();
      oloeLightboxState.images = images;
      oloeLightboxState.index = index;
      oloeRenderLightbox(lb);
      lb.classList.add('is-open');
      document.body.classList.add('oloe-lightbox-open');
    }

    function oloeInitGalleryLightbox(root) {
      root = root || document;
      root.querySelectorAll('.pdp-images .stacked-gallery').forEach(function (galleryEl) {
        if (galleryEl.dataset.lightboxBound === 'true') return;
        galleryEl.dataset.lightboxBound = 'true';

        galleryEl.addEventListener('click', function (evt) {
          if (!oloeIsDesktopViewport()) return;
          var img = evt.target.closest('img[data-lightbox-full]');
          if (!img) return;
          var images = oloeGetGalleryImages(galleryEl);
          var clickedFull = img.getAttribute('data-lightbox-full');
          var index = images.findIndex(function (item) { return item.full === clickedFull; });
          oloeOpenLightbox(images, index === -1 ? 0 : index);
        });
      });
    }

    function oloeInitAll() {
      oloeInitCountdowns();
      oloeInitGalleryLightbox();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', oloeInitAll);
    } else {
      oloeInitAll();
    }

    document.addEventListener('shopify:section:load', function (evt) {
      evt.target.querySelectorAll('.oloe-countdown-timer[data-end]').forEach(oloeStartCountdown);
      oloeInitGalleryLightbox(evt.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
